import QrCanvas from '@/components/qr-canvas';

interface TicketQrCodeProps {
  barcode: string;
  alt: string;
}

const TicketQrCode = ({ barcode, alt }: TicketQrCodeProps) => (
  <QrCanvas
    value={barcode}
    alt={alt}
    errorCorrectionLevel="H"
    margin={4}
    className="mx-auto w-[59%]"
    canvasClassName="rounded-2"
  />
);

export default TicketQrCode;
